module.exports = __webpack_public_path__ + "static/media/AI_Summary_White icon.d1a3527a.svg";